import { SvgIcon } from "@mui/material";

const ReplyIcon = ({...props}) => (
  <SvgIcon {...props} width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 14C18 14 15.775 4.06649 7 4.06649V0L0 6.7091L7 13.5376V9.09041C11.763 9.08939 15.516 9.52012 18 14Z" fill="#807E78"/>
  </SvgIcon>
)

export default ReplyIcon;